import { Icon } from "@amzn/storm-ui";
import { exclamationTriangle } from "@amzn/storm-ui-icons";
import { useResizeObserver } from "@react-hookz/web";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
import React from "react";
import { Document, pdfjs, Page } from "react-pdf";

import { LoadingSpinner } from "../LoadingSpinner";

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

export interface PdfSelectionViewerProps {
    url: string;
    pageIndex: number;
}

const errorMessage = (): JSX.Element => {
    return (
        <h3>
            <Icon type={exclamationTriangle} style={{ color: "red" }} />
            There was an error loading the preview.
            <br />
            You can view the insights offline by using the Download button
            below.
        </h3>
    );
};

export const PdfWorkbenchViewer: React.FunctionComponent<
    PdfSelectionViewerProps
> = (props: PdfSelectionViewerProps) => {
    const { url, pageIndex } = props;

    const maxWidth = 950;
    const widthRef = React.useRef<HTMLDivElement>(null);
    const [width, setWidth] = React.useState(0);
    useResizeObserver(widthRef, (entry) => {
        setWidth(entry.target.clientWidth);
    });

    return (
        <div
            data-testid="pdf-workbench-viewer-container"
            style={{ justifyItems: "center" }}
            ref={widthRef}
        >
            <Document
                file={url}
                onLoadSuccess={() => {}}
                loading={<LoadingSpinner />}
                data-testid="pdf-workbench-viewer-document"
                noData={errorMessage}
                error={errorMessage}
            >
                <Page
                    key={`page_${pageIndex + 1}`}
                    pageNumber={pageIndex + 1}
                    scale="0.9"
                    width={width ? Math.min(width, maxWidth) : maxWidth}
                    renderAnnotationLayer={false}
                    renderTextLayer={false}
                />
            </Document>
        </div>
    );
};
